import styled from 'styled-components';

export const DecisionCardBox = styled.div<{ $variant: 'approved' | 'rejected' }>`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 1rem;
	border-radius: 0.5rem;
	border: 1px solid
		${({ theme, $variant }) =>
			$variant === 'approved' ? theme.v3.colors.teal[8] : theme.v3.colors.red[6]};
	background: transparent;
`;

export const DecisionRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const RejectionCommentBox = styled.div`
	display: flex;
	gap: 0.5rem;
	padding: 0.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[3]};
	border-radius: 0.25rem;
`;
